module.exports = __webpack_public_path__ + "media/images/application/icons/logo-zed-1b5e7532ca7e3950eeac021ec86bf619.svg";